export const ABSOLUTE_SIZE_REGEX = /[pbm]\{\s*(\d*[.]?\d+)\s*(mm|cm|pt|in)\s*\}/;

export const RELATIVE_SIZE_REGEX = /[pbm]\{\s*(\d*[.]?\d+)\s*\\(linewidth|textwidth|columnwidth)\s*\}/;

export const UNITS = ["%", "mm", "cm", "in", "pt", "custom"];
